import firebase, { userRef } from "../firebase/index"

export const initialState = {
  loginUser: {
    user: {
      company: '', // 廃止
      companyInfo: {},　// 入れ替え
      name: '',
      uid: '',
      email: '', // firebase auth
      imageUrl: '',
    },
    isLogin: false,
  }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'RESET':
      console.log("RESET");
      return initialState.loginUser
    case 'SET_LOGIN_USER':
      return {
        ...state,
        user: action.data,
        isLogin: true,
      }
    case 'SET_LOGIN_COMPANY':
      return {
        ...state,
        user: {
          ...state.user,
          companyInfo: action.data
        }
      }
    default: return state
  }
}

const normalizeLoginUser = (authUser, userId, userData) => ({
  ...userData,
  email: userData.email || authUser.email || '',
  uid: userData.uid || authUser.uid,
  userId,
})

const pickFirstUser = (users = null) => {
  if (!users) return null

  const [userId, userData] = Object.entries(users)[0] || []
  if (!userId || !userData) return null

  return { userId, userData }
}

export const resolveLoginUser = async (authUser) => {
  if (!authUser) return null

  const { uid, email } = authUser

  // 現行データは uid で引ける想定。まずは最短経路を試す。
  let snapshot = await userRef
    .orderByChild('uid')
    .equalTo(uid)
    .limitToFirst(1)
    .once('value')

  let resolved = pickFirstUser(snapshot.val())
  if (resolved) {
    return normalizeLoginUser(authUser, resolved.userId, resolved.userData)
  }

  // 一部の旧データは users/{uid} 直下に保存されている想定でフォールバックする。
  snapshot = await userRef.child(uid).once('value')
  if (snapshot.exists()) {
    return normalizeLoginUser(authUser, uid, snapshot.val())
  }

  if (!email) return null

  // uid で拾えない古いアカウント向けに email でも最後の救済を行う。
  snapshot = await userRef
    .orderByChild('email')
    .equalTo(email)
    .limitToFirst(1)
    .once('value')

  resolved = pickFirstUser(snapshot.val())
  if (!resolved) return null

  return normalizeLoginUser(authUser, resolved.userId, resolved.userData)
}

export const actions = {
  loginCheck: async (dispatch, history) => {
    console.log("login start")
    const handleResolvedUser = async (authUser) => {
      if (!authUser) {
        console.log("ログインしていません")
        dispatch({ type: 'RESET' })
        history.push('/login')
        return
      }

      try {
        const loginUser = await resolveLoginUser(authUser)

        if (!loginUser) {
          dispatch({ type: 'ERROR', data: 'ユーザー情報が取得できませんでした。管理者にご連絡ください。' })
          await firebase.auth().signOut()
          dispatch({ type: 'RESET' })
          history.push('/login')
          return
        }

        dispatch({
          type: 'SET_LOGIN_USER',
          data: loginUser,
        })
      } catch (error) {
        console.error("loginCheck error", error)
        dispatch({ type: 'ERROR', data: error.message || 'ログイン情報の取得に失敗しました。' })
        await firebase.auth().signOut().catch(() => {})
        dispatch({ type: 'RESET' })
        history.push('/login')
      }
    }

    const currentUser = firebase.auth().currentUser
    if (currentUser) {
      // 既に Auth が確定している画面では、余分な監視を貼らず即解決する。
      await handleResolvedUser(currentUser)
      return () => {}
    }

    // currentUser が未確定の初回表示だけ one-shot で auth 状態を待つ。
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe()
      handleResolvedUser(user)
    })

    return unsubscribe
  },
  login: (user, currentPassword) => firebase.auth()
    .signInWithEmailAndPassword(user.email, currentPassword)
    .then()
    .catch((error) => {
      throw new Error(`ログインに失敗しました ${error.message}`)
    })
}
